import React from "react";
import * as UI from "@goodgym/components";
import { timeIntervals, convertTo12HourFormat } from "./helper";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";


export type AvailabilityFormProps = {
  index: number;
  availability: { date: string; time: string }[];
  setAvailability: (a: { date: string; time: string }[]) => void;
};

const AvailabilityForm: React.FC<AvailabilityFormProps> = ({
  index,
  availability,
  setAvailability,
}) => {
  const selectedDate = availability[index]?.date
    ? new Date(availability[index].date)
    : null;

  const handleClear = () => {
    const updated = [...availability];
    updated[index] = { date: "", time: "" };
    setAvailability(updated);
  };

  return (
    <UI.Grid columnSpacing={5} container sx={{ mt: 2 }}>
      <UI.Grid item xs={12}>
        <UI.Grid container spacing={3}>
          <UI.Grid item xs={12} md={6}>
            <DatePicker
             
              label="Date"
              value={selectedDate}
              onChange={(newValue) => {
                let dateIso = "";
                if (newValue instanceof Date && !isNaN(newValue.getTime())) {
                  dateIso = newValue.toISOString();
                } else if (
                  typeof newValue === "object" &&
                  newValue !== null &&
                  typeof (newValue as any).toDate === "function"
                ) {
                  dateIso = (newValue as any).toDate().toISOString();
                } else {
                  dateIso = "";
                }
                const updated = [...availability];
                updated[index].date = dateIso;
                setAvailability(updated);
              }}
              renderInput={(params) => (
                <TextField {...params} fullWidth size="medium" />
              )}
            />
          </UI.Grid>

          <UI.Grid item xs={12} md={6}>
            <UI.FormControl fullWidth>
              <UI.InputLabel id="time-select-label">Time</UI.InputLabel>
              <UI.Select
                id="time-select"
                label="Time"
                onChange={(event) => {
                  const updated = [...availability];
                  updated[index].time = event.target.value;
                  setAvailability(updated);
                }}
                value={availability[index].time}
              >
                {timeIntervals.map((time) => (
                  <UI.MenuItem key={time} value={time} aria-label={time}>
                    {convertTo12HourFormat(time)}
                  </UI.MenuItem>
                ))}
              </UI.Select>
            </UI.FormControl>
          </UI.Grid>
          <UI.Grid item xs={12} md={2}>
            <UI.Button
              variant="outlined"
              color="secondary"
              onClick={handleClear}
              fullWidth
            >
              Clear
            </UI.Button>
          </UI.Grid>
        </UI.Grid>
      </UI.Grid>
    </UI.Grid>
  );
};

export default AvailabilityForm;
